<i18n locale="en">
{
  "missing": "Missing:",
  "remove": "Remove:",
  "app-unavailable": "Get the App Buttons — no apps are live",
  "warnings": {
    "item": "Menu Item",
    "coupon": "Coupon",
    "heading": "Text (heading)",
    "subheading": "Text (subheading)",
    "paragraph": "Text (paragraph)",
    "image": "Image",
    "text": "Text message body"
  }
}
</i18n>

<template>
  <div class="invalid-configuration-content">
    <div class="flex-col gap-6">
      <div v-if="warnings.length" class="flex-col gap-2">
        <OwnType variant="title-regular" color="primary" :text="t('missing')" />
        <ul class="invalid-configuration-content__list">
          <li v-for="(warning, i) in warnings" :key="i">
            <OwnType
              variant="paragraph-regular"
              color="primary"
              :text="t(`warnings.${warning}`)"
            />
          </li>
        </ul>
      </div>
      <div v-if="hasAppUnavailable" class="flex-col gap-2">
        <OwnType variant="title-regular" color="primary" :text="t('remove')" />
        <ul class="invalid-configuration-content__list">
          <li>
            <OwnType
              variant="paragraph-regular"
              color="primary"
              :text="t('app-unavailable')"
            />
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n'

import { OwnType } from '@/ui/OwnType'

withDefaults(
  defineProps<{ warnings?: string[]; hasAppUnavailable?: boolean }>(),
  { hasAppUnavailable: false, warnings: () => [] }
)

const { t } = useI18n()
</script>

<style lang="scss" scoped>
.invalid-configuration-content {
  &__list {
    margin: 0;
    padding-left: 20px;
    list-style-type: disc;
  }
}
</style>
